import React, {useState, useEffect, useContext} from 'react';
import {matchPath} from 'react-router-dom';

const EntryModalContext = React.createContext();
EntryModalContext.displayName = 'EntryModalContext';

const EntryModalProvider = (props) => {
    const {gogInvitePopup, path} = props;
    const [isOpen, setIsOpen] = useState(false);
    const [gogInvitePopupValue, setGogInvitePopupValue] = useState(
        !!gogInvitePopup
    );
    const value = [
        isOpen,
        setIsOpen,
        gogInvitePopupValue,
        setGogInvitePopupValue,
    ];

    const isDetailsOrGuestPagePath =
        Boolean(
            matchPath(path, '/traveler/th/inbox/conversation/:id/details')
        ) ||
        Boolean(
            matchPath(
                path,
                '/traveler/th/inbox/conversation/:id/details/guests'
            )
        );

    useEffect(() => {
        const modalStateKey = 'inviteGuestsEntryModal';
        const modalState = window.localStorage.getItem(modalStateKey);
        let parsedModalStateJSON = null;
        try {
            parsedModalStateJSON = JSON.parse(modalState);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn(e);
        }
        // we set the localstorage and isOpen state when following conditions are met.
        // 1. gotInvitePopup value is true.
        // 2. Traveler is on /details or /details/guests route.
        // 3. Localstorage is not set already
        if (
            !parsedModalStateJSON &&
            gogInvitePopupValue &&
            isDetailsOrGuestPagePath
        ) {
            window.localStorage.setItem(modalStateKey, true);
            setIsOpen(true);
        }
    }, [gogInvitePopupValue, isDetailsOrGuestPagePath]);

    return <EntryModalContext.Provider value={value} {...props} />;
};

const useEntryModal = () => {
    const context = useContext(EntryModalContext);
    if (!context) {
        throw new Error('useEntryModal must be used in a EntryModalProvider');
    }
    return context;
};

export {EntryModalContext, EntryModalProvider, useEntryModal};
